module.exports = __webpack_public_path__ + "static/img/small_rash-01.2868a52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/small_rash-01.jpg
// module id = 291
// module chunks = 1